import React, { Component } from 'react'
import i18n from '../i18n.json'

class Terms extends Component {
  renderNav() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
      <div className="nav">
        <ul>
          <li className="left-corner">
            <a id="automagic-logo" href="/">
              automagic<br />.design
            </a>
          </li>
          <li>
              <a href="/">
                <div className="padding-bottom">
                  <h2><i className="fa fa-plus-square-o"></i></h2>
                  { i18n[selectedLanguage]['dashboard-menu-new-logo'] }
                </div>
              </a>
          </li>
        </ul>

      </div>
    )
  }

  renderContent() {
    return (
      <div className="fullpage">
        <div className="row">

           <div className="col-6 page-description">
            <h1>Terms of Service</h1>
            <p>Last update: January 30th, 2018</p>
           </div>

           <div className="col-6 page-content page-terms">
<p>
<h2>1. Terms</h2>

These terms are made in agreement between you (or "User") and automagic design (or "Automagic Design", "Codai", "codai", "we", "our", "us"). By accessing the website at https://automagic.design and any other automagic.design's subdomains and apps or products, you are agreeing to be bound by these Terms of Service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these Terms, you are prohibited from using or accessing this website and apps or using automagic design's products. The materials contained in this website and apps are protected by applicable copyright and trademark law.

<h2>2. Use License</h2>

Permission is granted to temporarily download one copy of the materials (information or software) on automagic design's website and apps for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:

modify or copy the materials;
use the materials for any commercial purpose, or for any public display (commercial or non-commercial);
attempt to decompile or reverse engineer any software contained on automagic design's website and apps;
remove any copyright or other proprietary notations from the materials; or
transfer the materials to another person or "mirror" the materials on any other server.

Only if you have purchased a Paid Design you have the right to download and use the materials (of the corresponding purchased Paid Design only) for personal or commercial purposes. To gain that right you must pay the fee stated on the automagic design's website or apps (see Section 3.1).

All of materials and Paid Designs and Temporary Designs that appear through automagic design's website and app, as well as trademarks and service marks, logos, slogans and taglines, are the property of automagic design. Except as otherwise specifically provided herein, nothing should be construed as granting any license or right to use any trademarks, service marks, logos, slogans or taglines displayed on the website and apps which are the property of automagic design. Any use of the materials for any purpose other than as specifically permitted herein or without our prior consent or the prior written consent of our licensors, as applicable, is expressly prohibited. We reserve all rights not expressly granted in these terms.

This license shall automatically terminate if you violate any of these restrictions and may be terminated by automagic design at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.

<h2>3. Service and Products</h2>

<h3>3.1 Paid Service and Designs</h3>

To use, copy, download and modify generated designs from automagic design (stated here as "Paid Design", "Paid Designs" or "product"), you must pay the fee stated on automagic design's website or apps. You may not use for personal or commercial purposes any material, content, Paid Design and Temporary Designs, nor on digital or physical media, without paying the applicable fee stated on automagic design's website or apps.

Under no circumstances will automagic design be responsible or guarantee the uniqueness and originality of the generated Paid Designs and their assets. Before using any purchased Paid Design we advise you to perform a complete research for trademarks and copyrights and any other third party rights that may be attained to the Paid Design itself. All use of the logo or brand of the Paid Design is at your own risk. You shall abide by all copyright notices, trademark rules, and shall not use, copy, reproduce, modify, translate, publish, broadcast, transmit, distribute, perform, upload, display, license, sub-license, rent, lend, assign, gift, sell or otherwise transfer or distribute for any purposes whatsoever any portion of the Paid Design not owned by you in any way that violates any third party right.

You will not create Paid Designs (nor Temporary Designs) using automagic design that are: pornographic, sexually explicit, violent, reasonably likely to cause harm, or that could be reasonably considered as slanderous or libelous.

You grant us the right to use Paid Designs purchased by you as promotional materials for automagic design marketing campaigns and to be public displayed on our website and apps.

<h3>3.2 Temporary Designs</h3>

During the process of generating Paid Designs, automagic design will generate Temporary Designs and will show to Users. However, Users don't have any right to use, copy, download or modify any of those designs other than the Paid Designs purchased by them.

<h3>3.3 Assets from Third Party Vendors</h3>

Automagic design may use assets from third party vendors, like images, color palettes, textual content, layout procedures, symbols, icons and fonts, and the license and agreement for those Assets (or "Asset") must follow their respective licenses and/or terms of service. Under no circumstances will automagic design be liable in any way for any Asset, including, but not limited to, for any loss or damage of any kind incurred as a result of the use of any content or any part thereof. You agree that you must evaluate, and bear all risks associated with, the use of any Asset, including, without limitation, the existence of any third party rights that may exist in such resources.

Before using any purchased Paid Design we advise you to perform a complete research for trademarks and copyrights and any other third party rights that may be attained to the assets (textual content, images, symbols, icons, colors, color palettes, layouts or fonts) used on your Paid Design, or the Paid Design itself (logo, brand). All use of these assets is at your own risk. You shall abide by all copyright notices, trademark rules, and shall not use, copy, reproduce, modify, translate, publish, broadcast, transmit, distribute, perform, upload, display, license, sub-license, rent, lend, assign, gift, sell or otherwise transfer or distribute for any purposes whatsoever any portion of the assets not owned by you: (i) without the express prior written consent of the respective owners or (ii) in any way that violates any third party right.

<h3>3.4 Hosting</h3>

You hereby grant automagic design a worldwide, royalty-free, non-exclusive license to host the generated Paid Designs and warrant that you have all the rights necessary to grant us such license. You are responsible for any content and/or products that may be lost or unrecoverable through your use of the services. We try our best to keep your purchased Paid Designs' data safe and available worldwide, however you are encouraged to back up your Paid Designs regularly and frequently. 

<h3>3.5 Data usage, processing and analysis</h3>

You grant automagic design a nonexclusive, irrevocable, worldwide, perpetual, unlimited, assignable, sublicenseable, fully paid up and royalty-free right to copy, prepare derivative works of, improve, distribute, publish, remove, retain, add, modify, process, analyze, use, your work and content (Paid Designs, Temporary Designs and any information/data collected by automagic design) in any way solely for the purpose to enhance, to perform and to promote automagic design services and products.

<h2>4. Disclaimer</h2>

The materials on automagic design's website and apps are provided on an 'as is' basis. automagic design makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
Further, automagic design does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.

<h2>5. Fees</h2>

You understand that additional services or products or Paid Designs or Temporary Designs that may be introduced in the future may be subject to additional fees. You further acknowledge and approve that automagic design reserves the right to change its fees at any time, at its sole discretion, upon notice to you if such change affect an existing subscription you own. If you received a discount for a subscription fee, or any other promotional offer for a subscription fee, we shall have the right to renew your subscription automatically and without notice at the full applicable fee.

<h2>6. Refund Policy</h2>

<h3>6.1 Refund for one time products (Paid Designs)</h3>

Paid Designs' fees are non-refundable. If you has reason to believe that you were charged on error you may provide a written notice to our email support and request to cancel your fee. When eligible, fee cancellation can be performed by automagic design's support only up to a period of 7 days from the fee payment date, and only if the Paid Design materials associated with the fee have not been downloaded or used outside of the automagic design's website or apps, whether for commercial or personal use. We will not cancel fees after that time or after a Paid Design has been downloaded or used outside of automagic design's website or apps. Eligibility to cancel a fee will be assessed by automagic design's support team based on a number of factors, including, without limitation, violations to these Terms of Service and improper usage of the automagic design's website or apps.

<h2>7. Termination Policy</h2>

We may suspend or terminate your rights to use our services and products (Paid Designs and Temporary Designs) at any time at our sole and absolute discretion, including, without limitation, for any use of the website or apps in violation of these Terms of Service. You understand that any termination of your account may involve deletion of your account, all information related thereof and the products associated therewith from our databases.

<h2>8. Limitations</h2>

In no event shall automagic design or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on automagic design's website and apps or products (Paid Designs and Temporary Designs), even if automagic design or a automagic design authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.

<h2>9. Accuracy of materials</h2>

The materials appearing on automagic design website and apps could include technical, typographical, or photographic errors. automagic design does not warrant that any of the materials on its website are accurate, complete or current. automagic design may make changes to the materials contained on its website and apps at any time without notice. However automagic design does not make any commitment to update the materials.

<h2>10. Links</h2>

automagic design has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by automagic design of the site. Use of any such linked website is at the user's own risk.

<h2>11. Modifications</h2>

automagic design may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.

<h2>12. Governing Law</h2>

These terms and conditions are governed by and construed in accordance with the laws of Brazil and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.

<h2>13. Contact</h2>

If you have any questions about these Terms, please contact us by sending an email to contact@automagic.design.

<h2>14. Legal Disclosure</h2>

Codai <br />
https://cod.ai <br />
contact@cod.ai <br />
Itajaí, SC, Brazil <br /> <br />

Represented by <br />
Gabriela Salvador Thumé <br />
Vilson Vieira da Silva Junior <br />
</p>
           </div>

        </div>
      </div>
    )
  }

  renderBottom() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
        <div>
         <div className="bottom bottom-left">
          <a href="/about">{ i18n[selectedLanguage]['bottom-about'] }</a> |
          <a href="/pricing"> { i18n[selectedLanguage]['bottom-pricing'] }</a> |
          <a href="mailto:contact@automagic.design"> { i18n[selectedLanguage]['bottom-contact'] }</a> |
          <a href="/tos"> { i18n[selectedLanguage]['bottom-tos'] }</a> |
          <a href="/privacy"> { i18n[selectedLanguage]['bottom-privacy'] }</a>
         </div>
         { /*
         <div className="bottom bottom-right">
          <a className="language-selector" href="/en" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('en') } }> EN</a> |
          <a className="language-selector" href="/pt" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('pt') } }> PT-BR</a>
         </div>
         */ }
        </div>
    )
  }

  render() {
    return (
      <div>
        { this.renderNav() }

        { this.renderContent() }

        { this.renderBottom() }
      </div>
    )
  }
}

export default Terms



// WEBPACK FOOTER //
// ./src/components/Terms.js